import React from 'react';
import {useTranslation} from 'react-i18next';
import BorderRadiusChange from '../../../common/borderRadiusChange';
import AccordionItem from '../../../../../../ui/components/AccordionItem';
import {ELEMENT} from '../../../../../../incase-domain/elements/base/ElementTypes';
import TextAlign from '../../../../../../ui/components/TextAlign';
import FontAndBackgroundColorPicker, {COLOR_FIELDS} from '../../../common/fontAndBackgroundColorPicker';
import {IElementQuestion} from '../../../../../../incase-domain/elements/question/question';
import {IElementMultiSelect} from '../../../../../../incase-domain/elements/question/multiSelect';
import {IQuestionElements} from '../../../../../../incase-domain/elements/question';
import DebouncedNumberInput from '../../../common/debounced/DebounceNumberInput';

interface AnswerAdvancedOptionsProps {
    highlightedElement: IQuestionElements;
    highlightedElementChangeHandler: {
        single: (field: keyof IQuestionElements | string, value: unknown) => void;
    };
    answerColorFields: COLOR_FIELDS[];
}

export default function AnswerAdvancedOptions(props: AnswerAdvancedOptionsProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler, answerColorFields} = props;

    const {t} = useTranslation();

    return (
        <AccordionItem header={<div className="u-flex u-h-between u-v-center">{t('designSidepanel.answer')}</div>}>
            <div className="l-group--form">
                <div className="l-group__item u-flex u-flex-col u-gap-2 u-pb-2">
                    {highlightedElement.type !== ELEMENT.PHOTO_ANSWER_QUESTION && (
                        <DebouncedNumberInput
                            label={t('designSidepanel.fontSize')}
                            value={highlightedElement.fontSize || 1}
                            onChange={(newValue: number) => highlightedElementChangeHandler.single('fontSize', newValue)}
                            min={0.1}
                            step={0.1}
                        />
                    )}
                    {highlightedElement.type === ELEMENT.MULTI_SELECT && (
                        <TextAlign
                            alignment={(highlightedElement as IElementQuestion | IElementMultiSelect).answerTextAlign}
                            onClick={(alignment) => {
                                highlightedElementChangeHandler.single('answerTextAlign', alignment);
                            }}
                        />
                    )}
                    {answerColorFields.length > 0 && (
                        <>
                            <FontAndBackgroundColorPicker
                                highlightedElement={highlightedElement}
                                highlightedElementChangeHandler={highlightedElementChangeHandler}
                                colorFields={answerColorFields}
                            />
                            {highlightedElement.type !== ELEMENT.QUESTION && (
                                <BorderRadiusChange
                                    borderRadius={highlightedElement.borderRadius}
                                    highlightedElementChangeHandler={(value) =>
                                        highlightedElementChangeHandler.single('borderRadius', value)
                                    }
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </AccordionItem>
    );
}
